import { createFileRoute } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";
import Admin from "@/pages/Admin";
import { ProtectedRoute } from "@/components/ProtectedRoute";

export const Route = createFileRoute("/admin")({
  head: noindexHead,
  component: () => (
    <ProtectedRoute>
      <Admin />
    </ProtectedRoute>
  ),
});
